// JsFromRoutes CacheKey 9e4060186d4a55aab45fd07ef894f368
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  reorder: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/articles/reorder'),
  cover: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/articles/:id/cover'),
  index: /* #__PURE__ */ definePathHelper('get', '/:account_id/help/articles'),
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/articles'),
  new: /* #__PURE__ */ definePathHelper('get', '/:account_id/help/articles/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/:account_id/help/articles/:id/edit'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/help/articles/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/help/articles/:id'),
}
